import React, { useState } from 'react';

import TopStrip from '../components/TopStrip';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HelpButton from '../components/HelpButton';

import heroBanner from '../assets/images/hero-images/contact us.webp';
import heroMobile from '../assets/images/mobile-banners/contact-mobile.webp';
import contactFormImg from '../assets/images/contact-page/contact-form-side-img.png';
import tab1 from '../assets/images/contact-tab/1.webp';
import tab2 from '../assets/images/contact-tab/2.webp';
import tab3 from '../assets/images/contact-tab/3.webp';
import amazonImg from '../assets/images/contact-tab/cloud-partner/amazon-services.409ec6fe.png';
import azureImg from '../assets/images/contact-tab/cloud-partner/microsoft-azure.d1ad17dd.png';
import linodeImg from '../assets/images/contact-tab/cloud-partner/linode-llc.e9505913.png';
import alibabaImg from '../assets/images/contact-tab/cloud-partner/alibaba-cloud.51dacd77.jpg';

const locations = [
  { region:'North America', addr:'2770 Coastal Bay Dr, Apt 105, Orange City, FL 32763', email:'contact@ddevops.com', phone:'(+1) 386 748 9010' },
  { region:'Asia (HQ)', addr:'1/44-A, Shah Faisal Colony, Shahrah-e-Faisal, Karachi, Pakistan.', email:'support@ddevops.com', phone:'(+92) 303 333 8766' },
  { region:'Europe', addr:'Stråkvägen 1, 169 35 Solna, Stockholm, Sweden', email:'contact@ddevops.com',   phone:'(+46) 793 466 263' }
];

function ContactUs() {
  const [activeTab, setActiveTab] = useState('services');
  const [formSent, setFormSent] = useState(false);
  const [formData, setFormData] = useState({ name:'', email:'', message:'' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append('access_key', '18c9761a-1b94-49be-9259-43d37e9c6067');
    fd.append('redirect', 'false');
    Object.entries(formData).forEach(([k,v]) => fd.append(k, v));
    const res = await fetch('https://api.web3forms.com/submit', { method:'POST', body:fd });
    const result = await res.json();
    if (result.success) setFormSent(true);
  };

  return (
    <>
      <TopStrip />
      <Navbar />

      {/* HERO */}
      <section style={{ marginTop:'125px' }}>
        <div className="container-fluid p-0">
          <img src={heroBanner} width="1600" height="520" alt="Contact DDevOps" className="img-fluid w-100 d-none d-md-block" />
          <img src={heroMobile} width="768" height="1000" alt="Contact DDevOps mobile" className="img-fluid w-100 d-md-none d-block" />
        </div>
      </section>

      {/* FORM SECTION */}
      <section className="my-5">
        <div className="container">
          <div className="text-center mb-5" data-aos="fade-up">
            <h1 className="top-line">Your Next Move Starts Here!</h1>
            <p>Let us know what you need — we'll tailor the solution.</p>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 col-sm-12 mb-4 mb-md-0 text-center" data-aos="zoom-in-up">
              <img src={contactFormImg} alt="Request Callback" className="img-fluid mb-3" style={{ maxWidth:'300px' }} />
              <p className="txt-color m-0 fw-bold">REQUEST A CALLBACK</p>
              <p className="text-muted">We will contact you in the shortest time.</p>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12" data-aos="zoom-in-down">
              {!formSent ? (
                <form className="p-4 rounded shadow-sm bg-white" onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <input type="text" name="name" className="form-control" placeholder="Your Name" required
                      value={formData.name} onChange={e => setFormData({...formData, name:e.target.value})} />
                  </div>
                  <div className="mb-3">
                    <input type="email" name="email" className="form-control" placeholder="Your Email" required
                      value={formData.email} onChange={e => setFormData({...formData, email:e.target.value})} />
                  </div>
                  <div className="mb-3">
                    <textarea name="message" rows="5" className="form-control" placeholder="Your Message" required
                      value={formData.message} onChange={e => setFormData({...formData, message:e.target.value})}></textarea>
                  </div>
                  <button type="submit" className="btn btn-info text-white fw-bold px-4">Send Inquiry</button>
                </form>
              ) : (
                <div className="alert alert-success mt-4">
                  <strong>Message Received. Stand By.</strong><br />
                  Thank you for contacting DDevOps. Your inquiry has been routed to our engineering desk. A representative will review your requirements and contact you shortly.
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* TABS SECTION */}
      <section id="tab-section">
        <div className="container text-center" style={{ marginTop:'5rem' }}>
          <h1 className="top-line">A Decade Of Digital <span className="text-info fw-bold">Excellence</span></h1>
        </div>
        <div className="container my-5 custom-tab-container">
          <ul className="nav nav-tabs justify-content-center" role="tablist">
            <li className="nav-item"><button className={`nav-link ${activeTab==='services'?'active':''}`} onClick={() => setActiveTab('services')} type="button">Our Expertise</button></li>
            <li className="nav-item"><button className={`nav-link ${activeTab==='partners'?'active':''}`} onClick={() => setActiveTab('partners')} type="button">Cloud Partners</button></li>
            <li className="nav-item"><button className={`nav-link ${activeTab==='mission'?'active':''}`}  onClick={() => setActiveTab('mission')}  type="button">Our Mission</button></li>
          </ul>
          <div className="tab-content pt-4">

            {/* OUR EXPERTISE */}
            <div className={`tab-pane fade ${activeTab==='services'?'show active':''}`}>
              <div className="row">
                {[
                  { img:tab1, title:'Technology Assurance', desc:'A holistic approach to core modernization. We ensure your infrastructure evolves faster than the market demands.' },
                  { img:tab2, title:'Certified Engineering Teams', desc:'Work with the best. Our engineers hold top-tier certifications in AWS, Kubernetes, and Security Compliance.' },
                  { img:tab3, title:'Zero-Trust Security', desc:'Security is not an addon. We implement rigorous, military-grade encryption and access controls from day one.' },
                ].map((c,i) => (
                  <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={i} data-aos="fade-up" data-aos-delay={i*150}>
                    <div className="text-center">
                      <img src={c.img} alt={c.title} className="img-fluid mb-3" style={{ height:'200px', width:'100%', objectFit:'cover' }} />
                      <h5 className="fw-bold">{c.title}</h5>
                      <p className="text-muted">{c.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* CLOUD PARTNERS */}
            <div className={`tab-pane fade ${activeTab==='partners'?'show active':''}`}>
              <div className="row mt-4 justify-content-center align-items-center">
                {[
                  { img:amazonImg, alt:'Amazon Web Services' },
                  { img:azureImg,  alt:'Microsoft Azure' },
                  { img:linodeImg, alt:'Linode LLC' },
                  { img:alibabaImg,alt:'Alibaba Cloud' },
                ].map((p,i) => (
                  <div className="col-lg-3 col-md-6 col-sm-12 mb-4" key={i} data-aos="zoom-in" data-aos-delay={i*100}>
                    <div className="text-center">
                      <img src={p.img} alt={p.alt} className="img-fluid mb-3" style={{ height:'100px', width:'auto' }} />
                      <p className="fw-semibold">{p.alt}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* OUR MISSION */}
            <div className={`tab-pane fade ${activeTab==='mission'?'show active':''}`}>
              <div className="row align-items-center mt-4">
                <div className="col-lg-6 col-md-6 col-sm-12 mb-4" data-aos="fade-right">
                  <h5 className="fw-bold mb-3">Empowering the Next Generation of Tech</h5>
                  <ul className="text-start">
                    <li>Building resilient, self-healing infrastructure.</li>
                    <li>Reducing carbon footprint through optimized cloud usage.</li>
                    <li>Securing global data with advanced compliance standards.</li>
                    <li>Democratizing DevOps for startups and enterprises alike.</li>
                  </ul>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 text-center" data-aos="fade-left">
                  <div className="ratio ratio-16x9">
                    <iframe src="https://www.youtube.com/embed/Q_5hfx_Cd-E?autoplay=0&rel=0"
                      title="Our Mission Video" allowFullScreen
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
                    </iframe>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* GLOBAL PRESENCE */}
      <section className="py-5 position-relative global-presence-section">
        <div className="overlay position-absolute w-100 h-100" style={{ top:0, left:0, backgroundColor:'rgba(0,0,0,0.6)', zIndex:1 }}></div>
        <div className="container position-relative" style={{ zIndex:2 }}>
          <div className="text-center mb-5 text-white">
            <h2 className="fw-bold">Global Operations. <span className="text-info">Local Support.</span></h2>
            <p className="mt-2">Serving clients worldwide with region-specific expertise and support.</p>
          </div>
          <div className="row g-4">
            {locations.map((loc,i) => (
              <div className="col-md-4" key={i} data-aos="fade-up" data-aos-delay={i*100}>
                <div className="h-100 p-4 bg-white shadow-sm rounded-3 border-top border-info border-3">
                  <h5 className="fw-bold mb-3 text-uppercase">{loc.region}</h5>
                  <p className="mb-2" dangerouslySetInnerHTML={{ __html: loc.addr.replace(/,\s*/g, ', ') }}></p>
                  <p className="mb-1"><strong>Email:</strong> {loc.email}</p>
                  <p className="mb-0"><strong>Phone:</strong> {loc.phone}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* LEGAL MARQUEE */}
      <section className="legal-strip">
        <div className="legal-marquee">
          <div className="legal-marquee__inner">
            {[1,2].map(n => (
              <span key={n}>
                <strong>Important Notice:</strong> The information provided via this contact form is for preliminary inquiry purposes only. While DDevOps maintains 24/7 readiness for contracted partners, response times for general web inquiries may vary. Submitting this form does not constitute a binding Service Level Agreement (SLA). &nbsp;&nbsp;|&nbsp;&nbsp; <strong>Data Privacy:</strong> Your details are encrypted and processed strictly in accordance with our Privacy Policy. We do not share your information with third parties.
              </span>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <HelpButton />
    </>
  );
}

export default ContactUs;
